import { appSettings } from 'app/appSettings';
import moment from 'moment';
import { FlordersFilter } from './florders-filter.interface';

const twoWeeksAgo = moment();
twoWeeksAgo.subtract(2, 'weeks');
const twoWeeksAgoString = twoWeeksAgo.format(appSettings.DATE_FORMAT_MOMENT_REST);

export const initialStateFlordersFilter: FlordersFilter = {
  filterId: 0,
  orderTypes: [],
  flowTypes: [],
  florderDateFrom: twoWeeksAgoString,
  florderDateTo: null,
  florderDefinitiveDateFrom: null,
  florderDefinitiveDateTo: null,
  unloadingDateFrom: null,
  unloadingDateTo: null,
  orderStatus: null,
  sealNumber: '',
  customers: null,
  ccrYes: false,
  ccrNo: false,
  palletIds: [],
  packingIds: [],
  customerReferenceNumber: '',
  senderReferenceNumber: '',
  salesOrderNumber: '',
  etmDocumentNumber: '',
  etmShippingNumber: '',
  transporter: '',
  froms: [],
  tos: [],
  shipTos: [],
  shippingCondition: [],
  incoterms: [],
  statusHandshake: false,
  statusDefinitive: false,
  statusCancel: false,
  differenceYes: true,
  differenceNo: true,
  clearingYes: true,
  clearingNo: true,
  handshakeDateFrom: null,
  handshakeDateTo: null,
  checkedYes: true,
  checkedNo: true,
  flowStatuses: [],
  orderStatuses: [],

  moreSearchOptions: false,

  pageNr: 1,
  pageSize: appSettings.PAGE_SIZE,
  sortField: 'etmOrderNumber',
  sortAscending: false,
};
